<ng-container *ngIf="showButton; else noAudit">
  <ng-template #auditPopover>
    <div *ngIf="loading" class="text-muted small py-1">Loading audit...</div>
    <table *ngIf="!loading && auditInfo?.createdAt; else noAuditContent" class="table table-sm table-bordered mb-0 audit-popover-table">
      <tbody>
        <tr>
          <th>Created By</th>
          <td>{{ auditInfo?.createdByName || '-' }}</td>
        </tr>
        <tr>
          <th>Created Date</th>
          <td>{{ auditInfo?.createdAt | date:'dd MMM yyyy, hh:mm:ss a' }}</td>
        </tr>
        <tr>
          <th>Updated By</th>
          <td>{{ hasUpdatedAudit() ? (auditInfo?.updatedByName || '-') : '-' }}</td>
        </tr>
        <tr>
          <th>Updated Date</th>
          <td>{{ hasUpdatedAudit() ? (auditInfo?.updatedAt | date:'dd MMM yyyy, hh:mm:ss a') : '-' }}</td>
        </tr>
      </tbody>
    </table>
    <ng-template #noAuditContent>
      <div class="text-muted small py-1">No audit data</div>
    </ng-template>
  </ng-template>

  <button
    type="button"
    class="btn btn-link p-0 audit-badge-link"
    #popover="ngbPopover"
    [ngbPopover]="auditPopover"
    popoverClass="audit-popover"
    triggers="manual"
    autoClose="outside"
    (click)="onClick(popover)">
    {{ label }}
  </button>
</ng-container>

<ng-template #noAudit>
  <span class="text-muted">-</span>
</ng-template>
